import React from "react";

/**
 * Specification of props required to inject a "not found" fallback route into
 * the router.
 */
export type RouteNotFoundProps = {
    /**
     * The callback that'll be triggered, where you should render your desired
     * error page.
     *
     * If you return a promise, then the router will wait for your component to
     * be ready for rendering. This makes it easy to implement code splitting
     * and deferred content loading.
     */
    render?(path: string): Promise<React.JSX.Element | null> | React.JSX.Element | null;
};

/**
 * Use the <RouteNotFound ... /> component to declaratively inject a fallback
 * route if no other routes match the given path.
 */
// tslint:disable-next-line variable-name
export const RouteNotFound: React.FC<RouteNotFoundProps> = () => null;
